module.exports = __webpack_public_path__ + "statics/img/4.64c6da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/4.jpg
// module id = 7dje
// module chunks = 1